module.exports = __webpack_public_path__ + "assets/icons/ic_sort_by_alpha-0e86.svg";